import React, { useState, useEffect, useMemo } from 'react';
import { Button, Modal, Row, Col, Container, Card } from 'react-bootstrap';
import DataTable from './Stocktable';
import axios from 'axios';
import { format } from 'date-fns';



const Vendor_payment_Ladger_Details = () => {
    const token = localStorage.getItem('token');
    const account_ladger_id = localStorage.getItem('Le_orderid');
    const ven_ledger_id = localStorage.getItem('ven_ledger_id');
    const [loading, setLoading] = useState(false);
    const [data, setVenderlist] = useState([]);
    const [customerDuelist, setcustomerDuelist] = useState('');

    useEffect(() => {
        fetchVendor();
    }, [token]);


    // const fetchVendor = async () => {
    //     try {
    //         const response = await axios.get(`${process.env.REACT_APP_API_URL}Site-ledger-vendor-list/${account_ladger_id}/vendor_id/${ven_ledger_id}`, {
    //             headers: {
    //                 'Content-Type': 'application/json',
    //                 'x-access-token': token,
    //             },
    //         });
    //         // Set the data from OtherData array if available
    //         const otherData = response.data.data || [];
    //         setVenderlist(otherData);
    //     } catch (error) {
    //         console.error('Error fetching vendors:', error);
    //     }
    // };

        const fetchVendor = async () => {
            try {
                const response = await axios.post(`${process.env.REACT_APP_API_URL}Vendor-report-list/${ven_ledger_id}`,
                    { vendor_id: ven_ledger_id }, // Payload for the request
                    {
                        headers: {
                            'Content-Type': 'application/json',
                            'x-access-token': token,
                        },
                    });
    
                const filteredData = (response.data.data || []).filter(
                    item => item.manufacture === 'Manufacture' && item.create_order_id == account_ladger_id
                );
    
                setVenderlist(filteredData);
            } catch (error) {
                console.error('Error fetching Vendor report:', error);
            }
        };

    // Define columns
    const columns = useMemo(
        () => [
            {
                Header: 'Sr No',
                accessor: (row, i) => i + 1,
            },
            {
                Header: 'Date',
                accessor: 'created_at',
                Cell: ({ value }) => {
                    return format(new Date(value), 'dd-MM-yyyy');
                },
            },
            {
                Header: 'Customer Name',
                accessor: 'customer_name',
            },

            {
                Header: 'Amount',
                accessor: 'amount',
            },
            // {
            //     Header: 'Due Amount',
            //     accessor: 'due_amt',
            //     Cell: ({ value }) => (
            //         value !== undefined ? (
            //           new Intl.NumberFormat().format(value)
            //         ) : null
            //       ),
            // },
            // {
            //     Header: 'Account',
            //     accessor: 'account_name',
            // },
            // {
            //     Header: 'Payment Mode',
            //     accessor: 'account_mode',
            // },



        ],
        []
    );
    return (
        <>

            <div>
                <DataTable columns={columns} data={data} />
                {/* Example modal component */}
                <Modal id="add-units" show={false} onHide={() => { }}>
                    <Modal.Header closeButton>
                        <Modal.Title>Add New</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {/* Your modal content here */}
                        {/* This is just a placeholder, replace it with your actual modal content */}
                        <p>Modal Content</p>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => { }}>
                            Close
                        </Button>
                        <Button variant="primary" onClick={() => { }}>
                            Save Changes
                        </Button>
                    </Modal.Footer>
                </Modal>
            </div>
        </>

    );
};

export default Vendor_payment_Ladger_Details;
